import { ActionTree, Commit } from 'vuex';
import { IRootState } from '../root-state.store';
import { IProfileNotificationState } from './profile-notification-state.store';
import { PROFILE_NOTIFICATION, PROFILE_NOTIFICATION_LOADING, PROFILE_SET_NOTIFICATION, PROFILE_PATCH_NOTIFICATION, PROFILE_SET_NOTIFICATION_PATCH, REVERT_PROFILE_NOTIFICATION, PROFILE_NOTIFICATION_SET_LOADER_STATE, PROFILE_NOTIFICATION_LOADERS } from './profile-notification-types.store';
import { ActivityStatus } from '../../common/enums';
import { IProfileNotification } from '../../models/profile-notification';

export const actions: ActionTree<IRootState, IProfileNotificationState> = {


  [PROFILE_NOTIFICATION]: async ({ getters, commit, state }) => {
    if(getters.profileNotifications.length) return Promise.resolve()
    
    commit(PROFILE_NOTIFICATION_LOADING, ActivityStatus.Loading);
    commit(PROFILE_NOTIFICATION_SET_LOADER_STATE,
      { key: [PROFILE_NOTIFICATION_LOADERS.NOTIFICATIONS_DETAILS, PROFILE_NOTIFICATION_LOADERS.NOTIFICATIONS_SIDEBAR] , value: true })
    return getters.service!.getProfileNotification()
      .then(response => {
        commit(PROFILE_SET_NOTIFICATION, {
          activityStatus: ActivityStatus.Loaded,
          profileNotifications: response,
        })
        return Promise.resolve(response.data);
      })
      .catch(error => Promise.reject(error))
      .finally(() => {
        commit(PROFILE_NOTIFICATION_LOADING, ActivityStatus.LoadFailed)
        commit(PROFILE_NOTIFICATION_SET_LOADER_STATE, 
          { key: [PROFILE_NOTIFICATION_LOADERS.NOTIFICATIONS_DETAILS, PROFILE_NOTIFICATION_LOADERS.NOTIFICATIONS_SIDEBAR] , value: false })
      })
  }
  , [PROFILE_PATCH_NOTIFICATION]: async ({getters, commit, state}, payload) => {
    commit(PROFILE_NOTIFICATION_LOADING, ActivityStatus.Loading);

    return await getters.service!.updateProfileNotification(payload).then((notification: IProfileNotification) => {
      commit(PROFILE_SET_NOTIFICATION_PATCH, notification)
      commit(PROFILE_NOTIFICATION_LOADING, ActivityStatus.Loaded);
      return Promise.resolve(notification)
    })
    .catch(error => {
      commit(REVERT_PROFILE_NOTIFICATION)
      commit(PROFILE_NOTIFICATION_LOADING, ActivityStatus.LoadFailed);
      return Promise.reject(error);
    })
  }

}



// WEBPACK FOOTER //
// ./src/store/profile-notification/profile-notification-actions.store.ts